import {splitLocalePathname, stripDefaultLocalePrefix} from '../../i18n/locale';

const DEVELOPMENT_SEGMENTS = ['countries', 'projects', 'phases', 'unit-types'];

function sectionOf(pathname: string): string {
  return splitLocalePathname(pathname).path.split('/')[1] ?? '';
}

export function isLinkActive(pathname: string, href: string): boolean {
  const current = stripDefaultLocalePrefix(pathname);
  return current === href || current.startsWith(`${href}/`);
}

export function isDevelopmentsActive(pathname: string): boolean {
  return DEVELOPMENT_SEGMENTS.includes(sectionOf(pathname));
}
